import { api } from '@/lib/api-client';
import type { ProjectScaffold } from './types';

export async function generateScaffoldApi(description: string): Promise<ProjectScaffold> {
  const { data } = await api.post<{ scaffold: ProjectScaffold }>(
    '/projects/scaffold',
    { description },
    // A geração via Claude (opus + adaptive thinking) leva dezenas de segundos —
    // sobrescreve o timeout global de 30s do api-client só nesta chamada.
    { timeout: 180_000 },
  );
  return data.scaffold;
}

export async function downloadScaffoldApi(
  scaffold: ProjectScaffold,
): Promise<{ blob: Blob; filename: string }> {
  const res = await api.post<Blob>('/projects/scaffold/download', scaffold, {
    responseType: 'blob',
  });
  const disposition = res.headers['content-disposition'] ?? '';
  // RFC 5987 / 6266: filename="..." (sem aspas se sem espaços, mas o backend sempre manda com)
  const match = disposition.match(/filename="?([^"]+)"?/i);
  const filename = match?.[1] ?? `${scaffold.projectName}.zip`;
  return { blob: res.data, filename };
}
